<template>
  <div class="">
    <van-popup
      v-model="show"
      round
      position="bottom"
      :style="{ 'min-height': '30%', 'max-height': '80%' }"
      duration="0.2"
    >
      <div class="title">
        <div></div>
        <div class="title-tool">领取优惠券</div>
        <img
          src="@/assets/img/components/wechatBinding/icon_close.png"
          alt=""
          @click="closePop()"
        />
      </div>
      <div class="couppon_card_box">
        <ul>
          <li>
            <CouponCard
              v-for="(item, index) in couponList"
              :key="index"
              :couponInfo="item"
              class="couppon_card"
            >
              <div class="slot">
                <button @click="receiveCoupon(item, index)" v-if="!item.hasGetAlready">领取</button>
                <img v-else src="@/assets/img/productDetail/receive_success.png" alt="" />
              </div>
              <span v-if="item.optimalCoupon === 1" class="isRecommend">推荐</span>
            </CouponCard>
          </li>
        </ul>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { gioPlatform, getRegisterSourceInfo, replaceHyphens, timerYhqCount } from '@/utils/tools';
import CouponCard from '@/components/coupon/CouponCard.vue';
import { reqReceiveCoupon } from '@/api/coupon/index';
import { isminiLogin,GetDateStr } from '@/utils/tools';
import wx from 'weixin-js-sdk';


export default {
  components: {
    CouponCard,
  },
  data() {
    return {
      couponList: [], // 优惠券列表
      show: false,
      reqLoading: false,
      gioCourseId: this.$route.query.courseId,
      timers: null,
    };
  },
  props: {},
  computed: {
    ...mapState(['allAcvitity', 'userInfo']),
  },
  watch: {
    show(state) {
      if (!state) return;
      const { couponChooseRespList } = this.allAcvitity.couponDetailVO;
      this.couponList = couponChooseRespList;
      this.couponList.forEach((element) => {
        // let dateTimeInfo = null;
        // if (element.effectiveTimeType === 1) {
        //   dateTimeInfo = `领取后${element.effectiveDays}天内有效`;
        // } else {
        //   dateTimeInfo = `${element.effectiveTimeBegin}-${element.effectiveTimeEnd}`;
        // }
        Object.assign(element, { couponName: element.frontEndName });
        this.getCountTime(element);
      });
    },
  },
  created() {},
  mounted() {},
  destroyed() {
    clearInterval(this.timers);
  },
  methods: {
    // 倒计时
    getCountTime(element) {
      const { receiveTimeEnd } = element;
      // 当前时间戳
      const now = new Date().getTime();
      // 结束时间戳
      const end = new Date(replaceHyphens(receiveTimeEnd)).getTime();
      // 做判断当倒计时结束时都为0
      if (now >= end) {
        this.$set(element, 'dateTimeInfo', '-');
        return;
      }
      // 用结束时间减去当前时间获得倒计时时间戳
      let temp = end - now + 1000;
      this.timers = setInterval(() => {
        temp -= 1000;
        if (temp > 0) {
          this.$set(element, 'dateTimeInfo', `限时抢券：${timerYhqCount(temp)}`);
        } else {
          this.$set(element, 'dateTimeInfo', '-');
          clearInterval(this.timers);
        }
      }, 1000);
    },
    closePop() {
      clearInterval(this.timers);
      this.show = false;
    },
    async receiveCoupon(item, index) {
      if (!this.userInfo.id) {
        const { isApp = false } = this.$root.$data;
        if (isApp) {
          getRegisterSourceInfo(this, 'courseDetail', 5, true);
        } else if (this.$root.whatEev === 'miniprogram') {
          let url = window.location.href;
          isminiLogin(url);
        } else {
          const param = { redirect: '/courseDetail', ...this.$route.query };
          this.$router.push({ path: '/registrationLogin', query: param });
        }
        return;
      }
      const res = await reqReceiveCoupon({
        couponId: String(item.couponId),
        couponVersion: Number(item.couponVersion),
        isLink: 0,
        fitPlatform: 1,
        fitEndPoint: this.$root.$data.isApp ? 2 : 4,
        terminalMark: this.$global.terminalMark,
      });
      if (res.code === 0) {
        this.$toast('领取成功');
        Object.assign(item, { hasGetAlready: 1 });
        this.$set(this.couponList, index, item);
        this.openNotice(item);
      } else {
        this.$toast(res.msg);
      }
    },
    openNotice(item) {
      const { couponId, couponName, effectiveTimeType, effectiveTimeEnd, effectiveDays,effectiveHours } = item;
      const expireTime = [1,3,4].includes(effectiveTimeType) ? GetDateStr(effectiveTimeType === 1 ? effectiveDays : effectiveHours,effectiveTimeType) : effectiveTimeEnd;
      if (this.$root.$data.miniprogram) {
        console.log(item)
        wx.miniProgram.navigateTo({
          url: `/subPackages/openNotice/index?type=1&businessId=${couponId}&businessName=${couponName}&expireTime=${expireTime}`,
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .couponGet {
  display: none;
}
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 36px;

  .title-tool {
    padding: 29px 0;
    color: #333;
    font-weight: 600;
    font-size: 29px;
    text-align: center;
  }

  img {
    width: 29px;
    height: 29px;
  }
}
.couppon_card_box {
  min-height: 100px;
  max-height: 900px;
  overflow: hidden;
  ul {
    min-height: 100px;
    max-height: 900px;
    padding-bottom: 50px;
    overflow-y: auto;
    .couppon_card {
      position: relative;
      margin: 29px auto;
      .isRecommend {
        position: absolute;
        top: 0;
        right: 0;
        width: 58px;
        height: 33px;
        color: #fff;
        font-size: 22px;
        line-height: 33px;
        text-align: center;
        background: #ff6c02;
        border-radius: 0 5px 0 5px;
      }
      .slot {
        position: absolute;
        top: 0;
        right: 36px;
        z-index: 100;
        display: flex;
        align-items: center;
        height: 100%;
        button {
          width: 109px;
          height: 43px;
          color: #fff;
          font-size: 22px;
          line-height: 43px;
          text-align: center;
          background: #ff6c02;
          border: none;
          border-radius: 29px;
        }
        img {
          width: 116px;
        }
      }
    }
  }
}
::v-deep .couponCard .couponInfo .couponName {
  padding: 10px 0 10px 0;
}
</style>
